// Stock API service for fetching real stock data
// This service provides methods to search for stocks and get real-time data

// Configuration
let USE_MOCK_DATA = false; // Set to false to use real APIs
const TWELVE_DATA_BASE = "https://api.twelvedata.com";
const BUILTIN_TWELVE_DATA_API_KEY = "dd2a5eb4aeac47b0a088641afbbceaca";
const YAHOO_FINANCE_BASE = "https://query1.finance.yahoo.com";
const ALPHA_VANTAGE_API_KEY = null; // Add your Alpha Vantage API key here
const IEX_CLOUD_API_KEY = null; // Add your IEX Cloud API key here

// Legacy configuration (keeping for compatibility)
const API_KEY = process.env.ALPHA_VANTAGE_API_KEY || "demo";
const BASE_URL = "https://www.alphavantage.co/query";
const IEX_CLOUD_BASE = "https://cloud.iexapis.com/stable";
const IEX_API_KEY = process.env.IEX_API_KEY || "demo";
let runtimeTwelveDataApiKey = "";

// Sample stock data for demonstration when API is not available
const SAMPLE_STOCKS = [
  {
    symbol: "AAPL",
    name: "Apple Inc.",
    price: 189.98,
    change: 2.45,
    changePercent: 1.31,
  },
  {
    symbol: "MSFT",
    name: "Microsoft Corporation",
    price: 412.45,
    change: -1.23,
    changePercent: -0.3,
  },
  {
    symbol: "GOOGL",
    name: "Alphabet Inc.",
    price: 145.67,
    change: 0.89,
    changePercent: 0.61,
  },
  {
    symbol: "AMZN",
    name: "Amazon.com Inc.",
    price: 178.9,
    change: -0.56,
    changePercent: -0.31,
  },
  {
    symbol: "TSLA",
    name: "Tesla Inc.",
    price: 250.0,
    change: 5.67,
    changePercent: 2.32,
  },
  {
    symbol: "META",
    name: "Meta Platforms Inc.",
    price: 320.45,
    change: 1.23,
    changePercent: 0.39,
  },
  {
    symbol: "NVDA",
    name: "NVIDIA Corporation",
    price: 890.12,
    change: 12.34,
    changePercent: 1.41,
  },
  {
    symbol: "NFLX",
    name: "Netflix Inc.",
    price: 450.78,
    change: -2.34,
    changePercent: -0.52,
  },
  {
    symbol: "SPY",
    name: "SPDR S&P 500 ETF",
    price: 445.67,
    change: 0.45,
    changePercent: 0.1,
  },
  {
    symbol: "QQQ",
    name: "Invesco QQQ Trust",
    price: 378.9,
    change: 1.12,
    changePercent: 0.3,
  },
  {
    symbol: "VTI",
    name: "Vanguard Total Stock Market ETF",
    price: 235.45,
    change: 0.78,
    changePercent: 0.33,
  },
  {
    symbol: "VOO",
    name: "Vanguard S&P 500 ETF",
    price: 420.12,
    change: 0.34,
    changePercent: 0.08,
  },
  {
    symbol: "BTC",
    name: "Bitcoin",
    price: 52000,
    change: 1500,
    changePercent: 2.97,
  },
  {
    symbol: "ETH",
    name: "Ethereum",
    price: 3200,
    change: 120,
    changePercent: 3.9,
  },
  {
    symbol: "JPM",
    name: "JPMorgan Chase & Co.",
    price: 145.67,
    change: -0.89,
    changePercent: -0.61,
  },
  {
    symbol: "JNJ",
    name: "Johnson & Johnson",
    price: 165.43,
    change: 0.67,
    changePercent: 0.41,
  },
  {
    symbol: "PG",
    name: "Procter & Gamble Co.",
    price: 145.89,
    change: -0.23,
    changePercent: -0.16,
  },
  {
    symbol: "KO",
    name: "The Coca-Cola Company",
    price: 58.9,
    change: 0.45,
    changePercent: 0.77,
  },
  {
    symbol: "PEP",
    name: "PepsiCo Inc.",
    price: 167.34,
    change: 1.23,
    changePercent: 0.74,
  },
  {
    symbol: "WMT",
    name: "Walmart Inc.",
    price: 67.89,
    change: -0.67,
    changePercent: -0.98,
  },
  {
    symbol: "DIS",
    name: "The Walt Disney Company",
    price: 89.45,
    change: 1.23,
    changePercent: 1.39,
  },
  {
    symbol: "NKE",
    name: "NIKE Inc.",
    price: 98.76,
    change: -0.45,
    changePercent: -0.45,
  },
  {
    symbol: "HD",
    name: "The Home Depot Inc.",
    price: 345.67,
    change: 2.34,
    changePercent: 0.68,
  },
  {
    symbol: "UNH",
    name: "UnitedHealth Group Inc.",
    price: 523.45,
    change: -1.23,
    changePercent: -0.23,
  },
  {
    symbol: "MA",
    name: "Mastercard Inc.",
    price: 456.78,
    change: 3.45,
    changePercent: 0.76,
  },
  {
    symbol: "V",
    name: "Visa Inc.",
    price: 234.56,
    change: 1.23,
    changePercent: 0.53,
  },
  {
    symbol: "PYPL",
    name: "PayPal Holdings Inc.",
    price: 67.89,
    change: -0.78,
    changePercent: -1.14,
  },
  {
    symbol: "CRM",
    name: "Salesforce Inc.",
    price: 234.56,
    change: 2.34,
    changePercent: 1.01,
  },
  {
    symbol: "ADBE",
    name: "Adobe Inc.",
    price: 456.78,
    change: -3.45,
    changePercent: -0.75,
  },
  {
    symbol: "INTC",
    name: "Intel Corporation",
    price: 45.67,
    change: 0.23,
    changePercent: 0.51,
  },
  {
    symbol: "AMD",
    name: "Advanced Micro Devices Inc.",
    price: 123.45,
    change: 4.56,
    changePercent: 3.84,
  },
  {
    symbol: "ORCL",
    name: "Oracle Corporation",
    price: 123.45,
    change: 1.23,
    changePercent: 1.01,
  },
  {
    symbol: "IBM",
    name: "International Business Machines Corp.",
    price: 167.89,
    change: -0.45,
    changePercent: -0.27,
  },
  {
    symbol: "CSCO",
    name: "Cisco Systems Inc.",
    price: 48.9,
    change: 0.12,
    changePercent: 0.25,
  },
  {
    symbol: "TXN",
    name: "Texas Instruments Inc.",
    price: 167.34,
    change: -1.23,
    changePercent: -0.73,
  },
  {
    symbol: "QCOM",
    name: "QUALCOMM Inc.",
    price: 123.45,
    change: 2.34,
    changePercent: 1.93,
  },
  {
    symbol: "AVGO",
    name: "Broadcom Inc.",
    price: 890.12,
    change: 12.34,
    changePercent: 1.41,
  },
  {
    symbol: "MU",
    name: "Micron Technology Inc.",
    price: 78.9,
    change: 1.23,
    changePercent: 1.58,
  },
  {
    symbol: "T",
    name: "AT&T Inc.",
    price: 16.78,
    change: -0.12,
    changePercent: -0.71,
  },
  {
    symbol: "VZ",
    name: "Verizon Communications Inc.",
    price: 34.56,
    change: 0.23,
    changePercent: 0.67,
  },
  {
    symbol: "CMCSA",
    name: "Comcast Corporation",
    price: 45.67,
    change: -0.34,
    changePercent: -0.74,
  },
  {
    symbol: "CHTR",
    name: "Charter Communications Inc.",
    price: 234.56,
    change: 3.45,
    changePercent: 1.49,
  },
  {
    symbol: "FOX",
    name: "Fox Corporation",
    price: 34.56,
    change: 0.12,
    changePercent: 0.35,
  },
  {
    symbol: "FOXA",
    name: "Fox Corporation",
    price: 34.56,
    change: 0.12,
    changePercent: 0.35,
  },
  {
    symbol: "PARA",
    name: "Paramount Global",
    price: 12.34,
    change: -0.23,
    changePercent: -1.83,
  },
  {
    symbol: "WBD",
    name: "Warner Bros. Discovery Inc.",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "LUMN",
    name: "Lumen Technologies Inc.",
    price: 1.23,
    change: -0.05,
    changePercent: -3.91,
  },
  {
    symbol: "LUV",
    name: "Southwest Airlines Co.",
    price: 23.45,
    change: -0.34,
    changePercent: -1.43,
  },
  {
    symbol: "DAL",
    name: "Delta Air Lines Inc.",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "UAL",
    name: "United Airlines Holdings Inc.",
    price: 45.67,
    change: -0.67,
    changePercent: -1.45,
  },
  {
    symbol: "AAL",
    name: "American Airlines Group Inc.",
    price: 12.34,
    change: -0.23,
    changePercent: -1.83,
  },
  {
    symbol: "BA",
    name: "Boeing Co.",
    price: 234.56,
    change: 3.45,
    changePercent: 1.49,
  },
  {
    symbol: "CAT",
    name: "Caterpillar Inc.",
    price: 345.67,
    change: 4.56,
    changePercent: 1.34,
  },
  {
    symbol: "DE",
    name: "Deere & Company",
    price: 456.78,
    change: 5.67,
    changePercent: 1.26,
  },
  {
    symbol: "GE",
    name: "General Electric Company",
    price: 123.45,
    change: 1.23,
    changePercent: 1.01,
  },
  {
    symbol: "MMM",
    name: "3M Company",
    price: 89.45,
    change: -1.23,
    changePercent: -1.36,
  },
  {
    symbol: "HON",
    name: "Honeywell International Inc.",
    price: 234.56,
    change: 2.34,
    changePercent: 1.01,
  },
  {
    symbol: "UPS",
    name: "United Parcel Service Inc.",
    price: 167.89,
    change: -1.23,
    changePercent: -0.73,
  },
  {
    symbol: "FDX",
    name: "FedEx Corporation",
    price: 234.56,
    change: 2.34,
    changePercent: 1.01,
  },
  {
    symbol: "RTX",
    name: "Raytheon Technologies Corporation",
    price: 89.45,
    change: 1.23,
    changePercent: 1.39,
  },
  {
    symbol: "LMT",
    name: "Lockheed Martin Corporation",
    price: 456.78,
    change: 3.45,
    changePercent: 0.76,
  },
  {
    symbol: "NOC",
    name: "Northrop Grumman Corporation",
    price: 567.89,
    change: 4.56,
    changePercent: 0.81,
  },
  {
    symbol: "GD",
    name: "General Dynamics Corporation",
    price: 234.56,
    change: 2.34,
    changePercent: 1.01,
  },
  {
    symbol: "XOM",
    name: "Exxon Mobil Corporation",
    price: 89.45,
    change: 1.23,
    changePercent: 1.39,
  },
  {
    symbol: "CVX",
    name: "Chevron Corporation",
    price: 145.67,
    change: 2.34,
    changePercent: 1.63,
  },
  {
    symbol: "COP",
    name: "ConocoPhillips",
    price: 123.45,
    change: 1.23,
    changePercent: 1.01,
  },
  {
    symbol: "EOG",
    name: "EOG Resources Inc.",
    price: 89.45,
    change: -1.23,
    changePercent: -1.36,
  },
  {
    symbol: "SLB",
    name: "Schlumberger Limited",
    price: 45.67,
    change: 0.34,
    changePercent: 0.75,
  },
  {
    symbol: "HAL",
    name: "Halliburton Company",
    price: 34.56,
    change: 0.23,
    changePercent: 0.67,
  },
  {
    symbol: "BKR",
    name: "Baker Hughes Company",
    price: 23.45,
    change: 0.12,
    changePercent: 0.51,
  },
  {
    symbol: "KMI",
    name: "Kinder Morgan Inc.",
    price: 16.78,
    change: -0.12,
    changePercent: -0.71,
  },
  {
    symbol: "ENB",
    name: "Enbridge Inc.",
    price: 34.56,
    change: 0.23,
    changePercent: 0.67,
  },
  {
    symbol: "EPD",
    name: "Enterprise Products Partners L.P.",
    price: 23.45,
    change: 0.12,
    changePercent: 0.51,
  },
  {
    symbol: "MPC",
    name: "Marathon Petroleum Corporation",
    price: 145.67,
    change: 2.34,
    changePercent: 1.63,
  },
  {
    symbol: "PSX",
    name: "Phillips 66",
    price: 123.45,
    change: 1.23,
    changePercent: 1.01,
  },
  {
    symbol: "VLO",
    name: "Valero Energy Corporation",
    price: 89.45,
    change: -1.23,
    changePercent: -1.36,
  },
  {
    symbol: "HES",
    name: "Hess Corporation",
    price: 145.67,
    change: 2.34,
    changePercent: 1.63,
  },
  {
    symbol: "DVN",
    name: "Devon Energy Corporation",
    price: 67.89,
    change: 1.23,
    changePercent: 1.85,
  },
  {
    symbol: "PXD",
    name: "Pioneer Natural Resources Company",
    price: 234.56,
    change: 3.45,
    changePercent: 1.49,
  },
  {
    symbol: "MRO",
    name: "Marathon Oil Corporation",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "APA",
    name: "APA Corporation",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "OXY",
    name: "Occidental Petroleum Corporation",
    price: 56.78,
    change: 0.67,
    changePercent: 1.19,
  },
  {
    symbol: "FANG",
    name: "Diamondback Energy Inc.",
    price: 145.67,
    change: 2.34,
    changePercent: 1.63,
  },
  {
    symbol: "CTRA",
    name: "Coterra Energy Inc.",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "EQT",
    name: "EQT Corporation",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "RRC",
    name: "Range Resources Corporation",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "SWN",
    name: "Southwestern Energy Company",
    price: 6.78,
    change: 0.12,
    changePercent: 1.8,
  },
  {
    symbol: "CHK",
    name: "Chesapeake Energy Corporation",
    price: 78.9,
    change: 1.23,
    changePercent: 1.58,
  },
  {
    symbol: "AR",
    name: "Antero Resources Corporation",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "COG",
    name: "Cabot Oil & Gas Corporation",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "NBL",
    name: "Noble Energy Inc.",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "WLL",
    name: "Whiting Petroleum Corporation",
    price: 67.89,
    change: 1.23,
    changePercent: 1.85,
  },
  {
    symbol: "CLR",
    name: "Continental Resources Inc.",
    price: 45.67,
    change: 0.67,
    changePercent: 1.49,
  },
  {
    symbol: "NFX",
    name: "Newfield Exploration Company",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "GPOR",
    name: "Gulfport Energy Corporation",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "CRZO",
    name: "Carrizo Oil & Gas Inc.",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "LPI",
    name: "Laredo Petroleum Inc.",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "SM",
    name: "SM Energy Company",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "XEC",
    name: "Cimarex Energy Co.",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "PE",
    name: "Parsley Energy Inc.",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
  {
    symbol: "JAG",
    name: "Jagged Peak Energy Inc.",
    price: 34.56,
    change: 0.45,
    changePercent: 1.32,
  },
  {
    symbol: "QEP",
    name: "QEP Resources Inc.",
    price: 23.45,
    change: 0.34,
    changePercent: 1.47,
  },
];

// Mock search function using sample data
const searchStocksMock = (query) => {
  console.log("Using mock data for stock search");
  const searchTerm = query.toLowerCase().trim();

  const filtered = SAMPLE_STOCKS.filter(
    (stock) =>
      stock.symbol.toLowerCase().includes(searchTerm) ||
      stock.name.toLowerCase().includes(searchTerm)
  );

  const sorted = filtered.sort((a, b) => {
    const aSymbolMatch = a.symbol.toLowerCase().startsWith(searchTerm);
    const bSymbolMatch = b.symbol.toLowerCase().startsWith(searchTerm);

    if (aSymbolMatch && !bSymbolMatch) return -1;
    if (!aSymbolMatch && bSymbolMatch) return 1;

    return a.symbol.localeCompare(b.symbol);
  });

  return sorted.slice(0, 20);
};

const KNOWN_TWELVE_DATA_CRYPTO_SYMBOLS = new Set([
  "BTC",
  "ETH",
  "BNB",
  "SOL",
  "XRP",
  "ADA",
  "DOGE",
  "DOT",
  "LINK",
]);

const MARKET_OVERVIEW_SYMBOLS = [
  "AAPL",
  "MSFT",
  "GOOGL",
  "AMZN",
  "NVDA",
  "META",
  "TSLA",
  "BRK-A",
  "TSM",
  "LLY",
  "V",
  "JPM",
  "XOM",
  "AVGO",
  "WMT",
  "UNH",
  "MA",
  "PG",
  "JNJ",
  "ORCL",
  "SPY",
  "QQQ",
  "VTI",
  "EFA",
  "IEMG",
];

const EXTRA_MARKET_OVERVIEW_ITEMS = [
  { symbol: "BRK-A", name: "Berkshire Hathaway", type: "Common Stock" },
  { symbol: "TSM", name: "Taiwan Semiconductor Manufacturing", type: "Common Stock" },
  { symbol: "LLY", name: "Eli Lilly and Company", type: "Common Stock" },
  { symbol: "EFA", name: "iShares MSCI EAFE ETF", type: "ETF" },
  { symbol: "IEMG", name: "iShares Core MSCI Emerging Markets ETF", type: "ETF" },
  { symbol: "BTC", name: "Bitcoin", type: "Digital Currency", providerSymbol: "BTC/USD" },
  { symbol: "ETH", name: "Ethereum", type: "Digital Currency", providerSymbol: "ETH/USD" },
  { symbol: "BNB", name: "BNB", type: "Digital Currency", providerSymbol: "BNB/USD" },
  { symbol: "SOL", name: "Solana", type: "Digital Currency", providerSymbol: "SOL/USD" },
  { symbol: "XRP", name: "XRP", type: "Digital Currency", providerSymbol: "XRP/USD" },
  { symbol: "ADA", name: "Cardano", type: "Digital Currency", providerSymbol: "ADA/USD" },
  { symbol: "DOGE", name: "Dogecoin", type: "Digital Currency", providerSymbol: "DOGE/USD" },
  { symbol: "DOT", name: "Polkadot", type: "Digital Currency", providerSymbol: "DOT/USD" },
  { symbol: "LINK", name: "Chainlink", type: "Digital Currency", providerSymbol: "LINK/USD" },
];

function getTwelveDataApiKey() {
  return String(
    runtimeTwelveDataApiKey ||
      process.env.REACT_APP_TWELVEDATA_API_KEY ||
      process.env.TWELVEDATA_API_KEY ||
      BUILTIN_TWELVE_DATA_API_KEY ||
      ""
  ).trim();
}

function buildTwelveDataUrl(path, params = {}) {
  const apiKey = getTwelveDataApiKey();
  if (!apiKey) {
    throw new Error("Twelve Data API key is not configured.");
  }
  const query = Object.entries({ ...params, apikey: apiKey })
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join("&");
  return `${TWELVE_DATA_BASE}${path}${query ? `?${query}` : ""}`;
}

function parseNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function toIsoString(value) {
  if (typeof value !== "string" || !value.trim()) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const d = new Date(`${value}T00:00:00Z`);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  const d = new Date(value.replace(" ", "T"));
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

function toUnixSeconds(value) {
  const direct = parseNumber(value);
  if (direct != null) return direct;
  const iso = toIsoString(value);
  if (!iso) return null;
  return Math.floor(new Date(iso).getTime() / 1000);
}

function normalizeAppSymbol(symbol) {
  const normalized = String(symbol || "").trim().toUpperCase();
  if (/^[A-Z]{1,6}\.[A-Z]$/.test(normalized)) {
    return normalized.replace(".", "-");
  }
  return normalized;
}

function mapInstrumentType(type) {
  const normalized = String(type || "").trim();
  if (!normalized) return "EQUITY";
  if (/etf/i.test(normalized)) return "ETF";
  if (/digital currency|crypto/i.test(normalized)) return "CRYPTO";
  return normalized;
}

function getProviderSymbol(symbol, options = {}) {
  const raw = String(options.providerSymbol || symbol || "").trim().toUpperCase();
  if (!raw) return "";
  if (raw.includes("/")) return raw;
  if (options.forceCrypto === true || KNOWN_TWELVE_DATA_CRYPTO_SYMBOLS.has(raw)) {
    return `${raw}/USD`;
  }
  if (!raw.includes(".") && /^[A-Z]{1,6}-[A-Z]$/.test(raw)) {
    return raw.replace("-", ".");
  }
  return raw;
}

async function fetchTwelveDataJson(path, params = {}, fetchOptions = {}) {
  const url = buildTwelveDataUrl(path, params);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    ...(fetchOptions.bypassCache ? { cache: "no-store" } : {}),
  });
  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    throw new Error(`Twelve Data returned invalid JSON for ${path}`);
  }
  if (!response.ok) {
    const detail = data?.message || text || `HTTP ${response.status}`;
    throw new Error(`Twelve Data request failed: ${detail}`);
  }
  if (data?.status === "error" || data?.code || data?.message === "symbol_not_found") {
    throw new Error(data?.message || data?.code || "Twelve Data request failed");
  }
  return data;
}

async function mapWithConcurrency(items, concurrency, mapper) {
  const out = [];
  for (let i = 0; i < items.length; i += concurrency) {
    const chunk = items.slice(i, i + concurrency);
    const results = await Promise.all(chunk.map(mapper));
    out.push(...results);
  }
  return out;
}

function mapQuotePayloadToQuote(data, options = {}) {
  const price =
    parseNumber(data?.close) ??
    parseNumber(data?.price) ??
    parseNumber(data?.last) ??
    0;
  const previousClose = parseNumber(data?.previous_close);
  let dailyChange = parseNumber(data?.change);
  if (dailyChange == null && previousClose != null) {
    dailyChange = price - previousClose;
  }
  let dailyChangePercent = parseNumber(data?.percent_change);
  if (
    dailyChangePercent == null &&
    previousClose != null &&
    previousClose > 0 &&
    dailyChange != null
  ) {
    dailyChangePercent = (dailyChange / previousClose) * 100;
  }

  return {
    symbol: normalizeAppSymbol(options.appSymbol || data?.symbol || options.symbol),
    providerSymbol: String(data?.symbol || options.providerSymbol || options.symbol || "")
      .trim()
      .toUpperCase(),
    name: data?.name || options.name || normalizeAppSymbol(options.symbol || data?.symbol),
    price,
    change: dailyChange ?? 0,
    changePercent: dailyChangePercent ?? 0,
    dailyChange: dailyChange ?? 0,
    dailyChangePercent,
    regularMarketTime:
      parseNumber(data?.timestamp) ?? toUnixSeconds(data?.datetime) ?? null,
    volume: parseNumber(data?.volume) ?? 0,
    previousClose: previousClose ?? 0,
    open: parseNumber(data?.open) ?? price,
    high: parseNumber(data?.high) ?? price,
    low: parseNumber(data?.low) ?? price,
    marketCap: 0,
    currency: String(data?.currency || options.currency || "USD").trim().toUpperCase(),
    exchange: String(data?.exchange || options.exchange || "").trim() || null,
    exchangeName: String(data?.exchange || options.exchange || "").trim() || null,
    fullExchangeName: String(data?.exchange || options.exchange || "").trim() || null,
    exchangeTimezoneName:
      String(data?.exchange_timezone || options.exchangeTimezoneName || "").trim() ||
      null,
    type: options.type || "EQUITY",
    source: "twelvedata",
  };
}

async function getTwelveDataQuoteSnapshot(symbol, fetchOptions = {}, options = {}) {
  const providerSymbol = getProviderSymbol(symbol, options);
  const data = await fetchTwelveDataJson(
    "/quote",
    {
      symbol: providerSymbol,
      interval: "1day",
    },
    fetchOptions
  );
  return mapQuotePayloadToQuote(data, {
    ...options,
    symbol,
    providerSymbol,
  });
}

async function getTwelveDataTimeSeriesRows(symbol, params, fetchOptions = {}, options = {}) {
  const providerSymbol = getProviderSymbol(symbol, options);
  const data = await fetchTwelveDataJson(
    "/time_series",
    {
      symbol: providerSymbol,
      order: "asc",
      ...params,
    },
    fetchOptions
  );

  const values = Array.isArray(data?.values) ? data.values : [];
  return values
    .map((row) => {
      const price = parseNumber(row?.close);
      if (price == null) return null;
      return {
        price,
        date: String(row.datetime || "").split(" ")[0],
        isoDate: toIsoString(row.datetime),
      };
    })
    .filter(Boolean);
}

async function getTwelveDataQuoteWithWeeklyChange(symbol, fetchOptions = {}, options = {}) {
  const [quote, rows] = await Promise.all([
    getTwelveDataQuoteSnapshot(symbol, fetchOptions, options),
    getTwelveDataTimeSeriesRows(
      symbol,
      { interval: "1day", outputsize: 5 },
      fetchOptions,
      options
    ),
  ]);

  let change = quote.dailyChange ?? 0;
  let changePercent = quote.dailyChangePercent ?? 0;
  let weekAgoPrice = quote.price;

  if (rows.length >= 2) {
    weekAgoPrice = rows[0].price;
    const latest = rows[rows.length - 1].price;
    if (weekAgoPrice > 0) {
      change = latest - weekAgoPrice;
      changePercent = (change / weekAgoPrice) * 100;
    }
  }

  return {
    ...quote,
    change,
    changePercent,
    weekAgoPrice,
  };
}

/** Calendar chip range for portfolio / stock detail charts (ported from mobile). */
export function getStockDetailChipDateRange(timeFrame) {
  const tf = String(timeFrame || "").toLowerCase();
  if (tf === "1d" || tf === "max") return null;
  const today = new Date();
  const rangeEndStr = today.toISOString().split("T")[0];
  let rangeStart;
  switch (tf) {
    case "5d":
    case "1w":
      rangeStart = new Date(today);
      rangeStart.setDate(today.getDate() - 7);
      break;
    case "1mo":
      rangeStart = new Date(today);
      rangeStart.setMonth(today.getMonth() - 1);
      break;
    case "3mo":
      rangeStart = new Date(today);
      rangeStart.setMonth(today.getMonth() - 3);
      break;
    case "6mo":
      rangeStart = new Date(today);
      rangeStart.setMonth(today.getMonth() - 6);
      break;
    case "1y":
      rangeStart = new Date(today);
      rangeStart.setFullYear(today.getFullYear() - 1);
      break;
    case "5y":
      rangeStart = new Date(today);
      rangeStart.setFullYear(today.getFullYear() - 5);
      break;
    case "ytd":
      rangeStart = new Date(today.getFullYear(), 0, 1);
      break;
    default:
      return null;
  }
  return {
    rangeStartStr: rangeStart.toISOString().split("T")[0],
    rangeEndStr,
  };
}

/** Twelve Data params for portfolio charts (aligned with mobile app). */
export function getStockDetailChartTimeParams(timeFrame) {
  const tf = String(timeFrame || "").toLowerCase();
  if (tf === "1d") {
    return { interval: "5min", outputsize: 96 };
  }
  const range = getStockDetailChipDateRange(tf);
  if (!range) {
    return getTimeSeriesParamsForTimeFrame(timeFrame);
  }
  const { rangeStartStr, rangeEndStr } = range;
  const dated = { start_date: rangeStartStr, end_date: rangeEndStr };
  switch (tf) {
    case "5d":
    case "1w":
      return { ...dated, interval: "15min" };
    case "1mo":
      return { ...dated, interval: "2h" };
    case "6mo":
    case "3mo":
    case "ytd":
    case "1y":
      return { ...dated, interval: "1day" };
    case "5y":
      return { ...dated, interval: "1week" };
    default:
      return { ...dated, interval: "1day" };
  }
}

export function portfolioChartUsesTimestampPoints(timeFrame, mappedTimeFrame) {
  const mapped = String(mappedTimeFrame || "").toLowerCase();
  if (mapped === "1d" || mapped === "5d" || mapped === "1w") return true;
  return String(timeFrame || "").toLowerCase() === "1mo";
}

function getTimeSeriesParamsForTimeFrame(timeFrame) {
  const MIN_CHART_POINTS = 120;
  const tf = String(timeFrame || "1mo").toLowerCase();
  switch (tf) {
    case "1d":
      return { interval: "1min", outputsize: 390 };
    case "5d":
      return { interval: "5min", outputsize: 500 };
    case "1mo":
      return { interval: "30min", outputsize: 300 };
    case "3mo":
      return { interval: "1h", outputsize: 500 };
    case "6mo":
      return { interval: "1h", outputsize: 500 };
    case "ytd":
      return {
        interval: "1h",
        start_date: `${new Date().getUTCFullYear()}-01-01`,
        outputsize: 500,
      };
    case "1y":
      return { interval: "1day", outputsize: 300 };
    case "5y":
      return { interval: "1week", outputsize: 300 };
    case "max":
      return { interval: "1month", outputsize: Math.max(MIN_CHART_POINTS, 240) };
    default:
      return { interval: "1day", outputsize: MIN_CHART_POINTS };
  }
}

function buildOverviewUniverse() {
  const bySymbol = new Map();
  SAMPLE_STOCKS.filter((stock) => MARKET_OVERVIEW_SYMBOLS.includes(stock.symbol)).forEach(
    (stock) => {
      bySymbol.set(stock.symbol, {
        symbol: stock.symbol,
        name: stock.name,
        type: ["SPY", "QQQ", "VTI", "EFA", "IEMG"].includes(stock.symbol)
          ? "ETF"
          : "Common Stock",
      });
    }
  );
  EXTRA_MARKET_OVERVIEW_ITEMS.forEach((item) => {
    bySymbol.set(item.symbol, item);
  });
  return Array.from(bySymbol.values());
}

// Real API Integration Functions

// Yahoo Finance API - Symbol Search (Primary API)
const searchStocksYahooFinance = async (query) => {
  try {
    console.log(`Searching Yahoo Finance for: ${query}`);

    // Updated Yahoo Finance search URL with correct parameter name 'q'
    const searchUrl = `${YAHOO_FINANCE_BASE}/v1/finance/search?q=${encodeURIComponent(
      query
    )}&quotesCount=20&newsCount=0&enableFuzzyQuery=true&quotesQueryId=tss_match_phrase_query&multiQuoteQueryId=multi_quote_single_token_query&enableCb=false`;

    console.log("Yahoo Finance search URL:", searchUrl);

    const response = await fetch(searchUrl, {
      method: "GET",
      headers: {
        "User-Agent":
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36",
        Accept: "application/json",
        "Accept-Language": "en-US,en;q=0.9",
        "Accept-Encoding": "gzip, deflate, br",
        Connection: "keep-alive",
        "Upgrade-Insecure-Requests": "1",
      },
    });

    console.log("Yahoo Finance response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Yahoo Finance response error:", errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log("Yahoo Finance response data:", JSON.stringify(data, null, 2));

    if (!data.quotes || data.quotes.length === 0) {
      console.log("No results from Yahoo Finance");
      return [];
    }

    // Get initial results from search
    const initialResults = data.quotes.map((quote) => ({
      symbol: quote.symbol,
      name: quote.shortname || quote.longname || quote.symbol,
      type: quote.quoteType || "EQUITY",
      exchange: quote.exchange || "Unknown",
      price: quote.regularMarketPrice || 0,
      change: quote.regularMarketChange || 0,
      changePercent: quote.regularMarketChangePercent || 0,
      marketCap: quote.marketCap || 0,
      currency: quote.currency || "USD",
      volume: quote.regularMarketVolume || 0,
      previousClose: quote.regularMarketPreviousClose || 0,
    }));

    console.log(
      `Found ${initialResults.length} stocks from Yahoo Finance search`
    );

    // Fetch current prices for stocks that don't have price data
    const resultsWithPrices = await Promise.all(
      initialResults.map(async (stock) => {
        // If we already have price data, use it
        if (stock.price && stock.price > 0) {
          return stock;
        }

        // Otherwise, fetch current price
        try {
          console.log(`Fetching price for ${stock.symbol}...`);
          const quoteData = await getStockQuoteYahooFinance(stock.symbol);
          if (quoteData) {
            return {
              ...stock,
              price: quoteData.price,
              change: quoteData.change,
              changePercent: quoteData.changePercent,
              volume: quoteData.volume,
              previousClose: quoteData.previousClose,
            };
          }
        } catch (error) {
          console.error(
            `Failed to fetch price for ${stock.symbol}:`,
            error.message
          );
        }

        return stock;
      })
    );

    console.log(`Returning ${resultsWithPrices.length} stocks with price data`);
    return resultsWithPrices;
  } catch (error) {
    console.error("Yahoo Finance search error:", error);

    // If Yahoo Finance fails, try alternative search method
    try {
      console.log("Trying alternative Yahoo Finance search method...");
      return await searchStocksYahooFinanceAlternative(query);
    } catch (altError) {
      console.error("Alternative Yahoo Finance search also failed:", altError);
      throw error; // Throw original error
    }
  }
};

// Alternative Yahoo Finance search method
const searchStocksYahooFinanceAlternative = async (query) => {
  try {
    // Try a simpler search approach with correct parameter name
    const searchUrl = `${YAHOO_FINANCE_BASE}/v1/finance/search?q=${encodeURIComponent(
      query
    )}&quotesCount=10`;

    const response = await fetch(searchUrl);

    if (!response.ok) {
      throw new Error(`Alternative search failed: ${response.status}`);
    }

    const data = await response.json();

    if (!data.quotes || data.quotes.length === 0) {
      return [];
    }

    // Get initial results from search
    const initialResults = data.quotes.map((quote) => ({
      symbol: quote.symbol,
      name: quote.shortname || quote.longname || quote.symbol,
      type: quote.quoteType || "EQUITY",
      exchange: quote.exchange || "Unknown",
      price: quote.regularMarketPrice || 0,
      change: quote.regularMarketChange || 0,
      changePercent: quote.regularMarketChangePercent || 0,
      marketCap: quote.marketCap,
      currency: quote.currency || "USD",
      volume: quote.regularMarketVolume,
      previousClose: quote.regularMarketPreviousClose,
    }));

    // Fetch current prices for stocks that don't have price data
    const resultsWithPrices = await Promise.all(
      initialResults.map(async (stock) => {
        // If we already have price data, use it
        if (stock.price && stock.price > 0) {
          return stock;
        }

        // Otherwise, fetch current price
        try {
          console.log(
            `Fetching price for ${stock.symbol} (alternative method)...`
          );
          const quoteData = await getStockQuoteYahooFinance(stock.symbol);
          if (quoteData) {
            return {
              ...stock,
              price: quoteData.price,
              change: quoteData.change,
              changePercent: quoteData.changePercent,
              volume: quoteData.volume,
              previousClose: quoteData.previousClose,
            };
          }
        } catch (error) {
          console.error(
            `Failed to fetch price for ${stock.symbol} (alternative method):`,
            error.message
          );
        }

        return stock;
      })
    );

    return resultsWithPrices;
  } catch (error) {
    console.error("Alternative Yahoo Finance search error:", error);
    throw error;
  }
};

// Alpha Vantage API - Symbol Search (Backup)
const searchStocksAlphaVantage = async (query) => {
  try {
    const response = await fetch(
      `${BASE_URL}?function=SYMBOL_SEARCH&keywords=${encodeURIComponent(
        query
      )}&apikey=${API_KEY}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data["Error Message"]) {
      throw new Error(data["Error Message"]);
    }

    if (data["Note"]) {
      console.warn("API rate limit reached:", data["Note"]);
      return [];
    }

    const matches = data.bestMatches || [];

    return matches.map((match) => ({
      symbol: match["1. symbol"],
      name: match["2. name"],
      type: match["3. type"],
      region: match["4. region"],
      marketOpen: match["5. marketOpen"],
      marketClose: match["6. marketClose"],
      timezone: match["7. timezone"],
      currency: match["8. currency"],
      matchScore: match["9. matchScore"],
      // We'll need to fetch price data separately
      price: 0,
      change: 0,
      changePercent: 0,
    }));
  } catch (error) {
    console.error("Alpha Vantage search error:", error);
    throw error;
  }
};

// IEX Cloud API - Symbol Search (Backup)
const searchStocksIEXCloud = async (query) => {
  try {
    const response = await fetch(
      `${IEX_CLOUD_BASE}/search/${encodeURIComponent(
        query
      )}?token=${IEX_API_KEY}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data.map((item) => ({
      symbol: item.symbol,
      name: item.securityName,
      type: item.securityType,
      exchange: item.exchange,
      price: 0, // Need separate call for price
      change: 0,
      changePercent: 0,
    }));
  } catch (error) {
    console.error("IEX Cloud search error:", error);
    throw error;
  }
};

// Get real-time stock quote from Yahoo Finance (Primary)
const getStockQuoteYahooFinance = async (symbol) => {
  try {
    console.log(`Getting Yahoo Finance quote for: ${symbol}`);

    // Updated Yahoo Finance quote URL to fetch 5 days of data (weekly change)
    const quoteUrl = `${YAHOO_FINANCE_BASE}/v8/finance/chart/${symbol}?interval=1d&range=5d&includePrePost=false&events=div%2Csplit`;

    console.log("Yahoo Finance quote URL:", quoteUrl);

    const response = await fetch(quoteUrl, {
      method: "GET",
      headers: {
        "User-Agent":
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36",
        Accept: "application/json",
        "Accept-Language": "en-US,en;q=0.9",
        "Accept-Encoding": "gzip, deflate, br",
        Connection: "keep-alive",
      },
    });

    console.log("Yahoo Finance quote response status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Yahoo Finance quote response error:", errorText);
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log(
      "Yahoo Finance quote response data:",
      JSON.stringify(data, null, 2)
    );

    if (!data.chart || !data.chart.result || data.chart.result.length === 0) {
      console.log("No quote data from Yahoo Finance");
      return null;
    }

    const result = data.chart.result[0];
    const meta = result.meta;
    const quote = result.indicators.quote[0];
    const timestamps = result.timestamp;

    // Get current price with fallback
    const currentPrice = meta.regularMarketPrice || 0;

    // Calculate weekly change (5 days ago to today)
    let weeklyChange = 0;
    let weeklyChangePercent = 0;
    let weekAgoPrice = currentPrice;

    if (
      timestamps &&
      timestamps.length >= 5 &&
      quote.close &&
      quote.close.length >= 5
    ) {
      // Get the price from 5 days ago (first day in the range)
      weekAgoPrice = quote.close[0] || currentPrice;

      if (currentPrice && weekAgoPrice && weekAgoPrice > 0) {
        weeklyChange = currentPrice - weekAgoPrice;
        weeklyChangePercent = (weeklyChange / weekAgoPrice) * 100;
      }
    }

    // Get previous close for daily change
    const previousClose = meta.previousClose || currentPrice;
    let dailyChange = 0;
    let dailyChangePercent = 0;

    if (currentPrice && previousClose && previousClose > 0) {
      dailyChange = currentPrice - previousClose;
      dailyChangePercent = (dailyChange / previousClose) * 100;
    }

    // Get volume with fallback
    const volume =
      quote.volume && quote.volume.length > 0
        ? quote.volume[quote.volume.length - 1] || 0
        : 0;

    // Get open price with fallback
    const open =
      quote.open && quote.open.length > 0
        ? quote.open[quote.open.length - 1] || currentPrice
        : currentPrice;

    // Get high and low with validation
    let high = currentPrice;
    let low = currentPrice;

    if (quote.high && quote.high.length > 0) {
      const validHighs = quote.high.filter(
        (h) => h !== null && h !== undefined && !isNaN(h)
      );
      if (validHighs.length > 0) {
        high = Math.max(...validHighs);
      }
    }

    if (quote.low && quote.low.length > 0) {
      const validLows = quote.low.filter(
        (l) => l !== null && l !== undefined && !isNaN(l)
      );
      if (validLows.length > 0) {
        low = Math.min(...validLows);
      }
    }

    const quoteData = {
      symbol: meta.symbol,
      name: meta.symbol, // We'll get the name from search results
      price: currentPrice,
      change: weeklyChange, // Use weekly change instead of daily
      changePercent: weeklyChangePercent, // Use weekly change percent
      dailyChange: dailyChange, // Keep daily change for reference
      dailyChangePercent: dailyChangePercent,
      weekAgoPrice: weekAgoPrice,
      volume: volume,
      previousClose: previousClose,
      open: open,
      high: high,
      low: low,
      marketCap: meta.marketCap || 0,
      currency: meta.currency || "USD",
    };

    console.log(`Quote data for ${symbol}:`, quoteData);
    return quoteData;
  } catch (error) {
    console.error("Yahoo Finance quote error:", error);
    throw error;
  }
};

// Get real-time stock quote from Alpha Vantage (Backup)
const getStockQuoteAlphaVantage = async (symbol) => {
  try {
    const response = await fetch(
      `${BASE_URL}?function=GLOBAL_QUOTE&symbol=${symbol}&apikey=${API_KEY}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data["Error Message"]) {
      throw new Error(data["Error Message"]);
    }

    if (data["Note"]) {
      console.warn("API rate limit reached:", data["Note"]);
      return null;
    }

    const quote = data["Global Quote"];
    if (!quote) return null;

    return {
      symbol: quote["01. symbol"],
      price: parseFloat(quote["05. price"]),
      change: parseFloat(quote["09. change"]),
      changePercent: parseFloat(quote["10. change percent"].replace("%", "")),
      volume: parseInt(quote["06. volume"]),
      previousClose: parseFloat(quote["08. previous close"]),
      open: parseFloat(quote["02. open"]),
      high: parseFloat(quote["03. high"]),
      low: parseFloat(quote["04. low"]),
    };
  } catch (error) {
    console.error("Alpha Vantage quote error:", error);
    throw error;
  }
};

// Main search function with smart fallback
export const searchStocks = async (query) => {
  if (!query || query.trim().length < 2) {
    return [];
  }

  const trimmedQuery = query.trim().toUpperCase();
  console.log(`Searching for stocks with query: "${trimmedQuery}"`);

  // If using mock data, return sample results
  if (USE_MOCK_DATA) {
    console.log("Using mock data for stock search");
    return searchStocksMock(trimmedQuery);
  }

  try {
    const data = await fetchTwelveDataJson("/symbol_search", {
      symbol: trimmedQuery,
      outputsize: 20,
    });

    const matches = Array.isArray(data?.data) ? data.data : [];
    if (!matches.length) {
      return [];
    }

    const baseResults = matches.map((item) => ({
      symbol: normalizeAppSymbol(item.symbol),
      providerSymbol: item.symbol,
      name: item.instrument_name || item.symbol,
      type: mapInstrumentType(item.instrument_type),
      exchange: item.exchange || "Unknown",
      currency: item.currency || "USD",
      change: 0,
      changePercent: 0,
      price: 0,
      volume: 0,
      previousClose: 0,
      exchangeTimezoneName: item.exchange_timezone || null,
    }));

    const enriched = await mapWithConcurrency(baseResults, 4, async (stock) => {
      try {
        const quote = await getTwelveDataQuoteSnapshot(
          stock.symbol,
          {},
          {
            ...stock,
            providerSymbol: stock.providerSymbol,
            forceCrypto: stock.type === "CRYPTO",
          }
        );
        return {
          ...stock,
          price: quote.price,
          change: quote.dailyChange ?? 0,
          changePercent: quote.dailyChangePercent ?? 0,
          volume: quote.volume ?? 0,
          previousClose: quote.previousClose ?? 0,
          currency: quote.currency || stock.currency || "USD",
        };
      } catch {
        return stock;
      }
    });

    return enriched;
  } catch (error) {
    console.error("Twelve Data search failed:", error.message);
    return [];
  }
};

// Enhanced quote function with Yahoo Finance as primary
export const getStockQuote = async (symbol) => {
  if (!symbol) return null;

  if (USE_MOCK_DATA) {
    const stock = SAMPLE_STOCKS.find(
      (s) => s.symbol.toUpperCase() === symbol.toUpperCase()
    );
    return stock || null;
  }

  try {
    return await getTwelveDataQuoteWithWeeklyChange(symbol);
  } catch (error) {
    console.warn("Twelve Data quote failed:", error.message);
  }
  return null;
};

// Get company overview from Yahoo Finance
export const getCompanyOverview = async (symbol) => {
  if (!symbol) return null;

  if (USE_MOCK_DATA) {
    const stock = SAMPLE_STOCKS.find(
      (s) => s.symbol.toUpperCase() === symbol.toUpperCase()
    );
    if (!stock) return null;

    return {
      symbol: stock.symbol,
      name: stock.name,
      description: `${stock.name} is a leading company in its industry.`,
      sector: "Technology",
      industry: "Software",
      marketCap: "2.5T",
      peRatio: "25.5",
      dividendYield: "0.5%",
      price: stock.price,
      change: stock.change,
      changePercent: stock.changePercent,
    };
  }

  try {
    const [profileResult, quoteResult] = await Promise.allSettled([
      fetchTwelveDataJson("/profile", {
        symbol: getProviderSymbol(symbol),
      }),
      getTwelveDataQuoteSnapshot(symbol),
    ]);

    const profile =
      profileResult.status === "fulfilled" ? profileResult.value : null;
    const quote = quoteResult.status === "fulfilled" ? quoteResult.value : null;

    if (!profile && !quote) {
      return null;
    }

    return {
      symbol: normalizeAppSymbol(profile?.symbol || quote?.symbol || symbol),
      name: profile?.name || quote?.name || normalizeAppSymbol(symbol),
      description:
        profile?.description ||
        `${profile?.name || quote?.name || normalizeAppSymbol(symbol)} is a publicly traded company.`,
      sector: profile?.sector || "Unknown",
      industry: profile?.industry || "Unknown",
      marketCap: "Unknown",
      peRatio: "Unknown",
      dividendYield: "Unknown",
      price: quote?.price ?? 0,
      change: quote?.dailyChange ?? quote?.change ?? 0,
      changePercent:
        quote?.dailyChangePercent != null ? quote.dailyChangePercent : quote?.changePercent ?? 0,
    };
  } catch (error) {
    console.error("Error fetching company overview:", error);
    return null;
  }
};

// Get historical data from Twelve Data
export const getHistoricalData = async (symbol, timeFrame = "1mo", options = {}) => {
  if (USE_MOCK_DATA) {
    return [];
  }

  try {
    const params =
      options.timeSeriesParamsOverride ||
      getTimeSeriesParamsForTimeFrame(timeFrame);
    const rows = await getTwelveDataTimeSeriesRows(symbol, params, {
      bypassCache: options.bypassCache,
    });
    return rows.map((row) => ({
      date: row.isoDate || `${row.date}T00:00:00.000Z`,
      price: row.price,
    }));
  } catch (error) {
    console.error("Error fetching historical data:", error);
    return []; // Return empty array on error
  }
};

// Configuration function for real API integration
export const configureApi = (
  apiKey,
  baseUrl = BASE_URL,
  useMockData = false
) => {
  USE_MOCK_DATA = useMockData;
  runtimeTwelveDataApiKey = String(apiKey || "").trim();
  console.log("API configured with key:", getTwelveDataApiKey() ? "***" : "missing");
  console.log("Using mock data:", useMockData);
  console.log("Primary API: Twelve Data");
};

// Get all available stocks (for real API, this would be a separate endpoint)
export const getAllStocks = async () => {
  if (USE_MOCK_DATA) {
    return SAMPLE_STOCKS;
  }
  const universe = buildOverviewUniverse();
  const results = await mapWithConcurrency(universe, 4, async (item) => {
    try {
      const quote = await getTwelveDataQuoteSnapshot(
        item.symbol,
        {},
        {
          ...item,
          providerSymbol: item.providerSymbol,
          forceCrypto: item.type === "Digital Currency",
        }
      );
      return {
        symbol: item.symbol,
        name: item.name || quote.name || item.symbol,
        type: item.type || quote.type || "EQUITY",
        exchange: quote.exchange || null,
        price: quote.price,
        change: quote.dailyChange ?? quote.change ?? 0,
        changePercent:
          quote.dailyChangePercent != null ? quote.dailyChangePercent : quote.changePercent ?? 0,
        currency: quote.currency || "USD",
      };
    } catch (error) {
      console.warn("getAllStocks quote failed:", item.symbol, error?.message || error);
      return null;
    }
  });
  return results.filter(Boolean);
};

export const getHistoricalPrice = async (symbol, date) => {
  if (!symbol || !date) return null;

  try {
    // We fetch 1 year of data to ensure the requested date is included.
    const allHistoricalData = await getHistoricalData(symbol, "1y");
    if (!allHistoricalData || allHistoricalData.length === 0) {
      console.warn(`No historical data for ${symbol} in the last year.`);
      return null;
    }

    // Find the data point for the target date, or the closest one before it.
    const targetDate = new Date(date);

    // Sort data descending to easily find the first date on or before the target.
    const sortedData = [...allHistoricalData].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );

    const priceData = sortedData.find((p) => new Date(p.date) <= targetDate);

    if (priceData) {
      return priceData.price;
    } else {
      console.warn(
        `No price data found for ${symbol} on or before ${targetDate.toISOString()}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      `Error fetching historical price for ${symbol} on ${date}:`,
      error
    );
    return null;
  }
};

export default {
  searchStocks,
  getStockQuote,
  getCompanyOverview,
  getHistoricalData,
  configureApi,
  getAllStocks,
  getHistoricalPrice,
};
